(function () {
    var componentId = 'hostDoraemonGlDetailsRevisionsComponent';
    var app = angular.module('app');

    function controller($state, $scope, $stateParams, $timeout, doraemonSvc, enumServiceRequestType) {
        var vm = this;
        vm.loading = 0;
        vm.letterNumber = $stateParams.letterNumber;

        vm.enums = {};
        vm.enums.serviceRequestType = enumServiceRequestType;

        var viewOptions = {
            maxResultCount: app.consts.grid.defaultPageSize,
            skipCount: 0,
            sorting: null
        };

        function init() {
            $timeout(function () {
                vm.revisionComponentGridOptions.paginationCurrentPage = Math.floor(viewOptions.skipCount / viewOptions.maxResultCount + 1);
            });
        }

        vm.revisionComponentGridOptions = {
            appScopeProvider: vm,
            paginationPageSizes: app.consts.grid.defaultPageSizes,
            paginationPageSize: app.consts.grid.defaultPageSize,
            paginationCurrentPage: 0,
            useExternalPagination: true,
            useExternalSorting: true,
            resizable: true,
            columnDefs: [{
                name: 'Actions',
                displayName: 'Actions',
                enableSorting: false,
                width: 100,
                headerCellTemplate: '<span></span>',
                cellTemplate: 'revisionComponentViewTemplate',
                allowCellFocus: false
            }, {
                displayName: App.localize('Name'),
                enableSorting: false,
                field: 'letterName',
                minWidth: 100,
                width: 150,
            }, {
                displayName: App.localize('RevisionNumber'),
                enableSorting: false,
                field: 'revisionNumber',
                minWidth: 120,
            }, {
                displayName: App.localize('RevisionType'),
                enableSorting: false,
                field: 'revisionType',
                minWidth: 120,
                cellTemplate: 'revisionTypeTemplate'
            }, {
                displayName: App.localize('ApprovalTime'),
                enableSorting: false,
                field: 'approvalTime',
                cellFilter: 'momentFormat: \'L LT\'',
                minWidth: 120
            }],
            onRegisterApi: function (gridApi) {
                $scope.gridApi = gridApi;

                $scope.gridApi.core.on.sortChanged($scope, function (scope, callback) {
                    viewOptions.sorting = callback.length && callback[0].field ? callback[0].field + ' ' + callback[0].sort.direction : null;
                    getGlRevision();
                });
                gridApi.pagination.on.paginationChanged($scope, App.setPagination(viewOptions, getGlRevision));
            },
            data: []
        };

        function getGlRevision() {
            vm.loading++;
            doraemonSvc.getGlRevision({
                letterNumber: vm.letterNumber,
                skipCount: viewOptions.skipCount,
                maxResultCount: viewOptions.maxResultCount
            }).success(function (data) {
                vm.revisionComponentGridOptions.totalItems = data.totalCount;
                vm.revisionComponentGridOptions.data = data.items;
            }).finally(function (e) {
                vm.loading--;
            });
        }

        init();
    }

    app.component(componentId, {
        templateUrl: require('/App/host/views/doraemon/glDetails/revisions/revisions.component.html'),
        controller: ['$state', '$scope', '$stateParams', '$timeout', 'abp.services.app.doraemon', 'Hms.ServiceRequests.ServiceRequestType', controller],
        controllerAs: 'vm'
    });
})();
